<!-- ToolButton.svelte -->
<script lang="ts">
  // Imports
  import { createEventDispatcher } from "svelte";

  // Props
  export let bottom: string;
  export let right = "15px";
  export let zIndex = "2000";
  export let pulsing = false;

  const dispatch = createEventDispatcher();

  // function handleClick() {
  //   dispatch("click");
  // }
</script>

<button
  on:click
  style="bottom: {bottom}; right: {right}; z-index: {zIndex}"
  class:pulsing
>
  <slot />
</button>

<style lang="scss">
  @import "../../styles/style.scss";

  button {
    border: none;
    border-radius: 100%;
    margin: 0;
    width: 40px;
    height: 40px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparentize($color-primary-white, 0.2);
    position: absolute;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  }

  .pulsing {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 1); 
    transform: scale(1); 
    animation: pulse 2s infinite;
  }
  @keyframes pulse {
    0% {transform: scale(0.95); box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);}
    70% {transform: scale(1); box-shadow: 0 0 0 30px rgba(0, 0, 0, 0);}
    100% {transform: scale(0.95); box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);}
  }

  </style>
